import React from 'react';
import { Box, Container, Heading, Text, VStack, SimpleGrid, Button, List, ListItem, ListIcon } from '@chakra-ui/react';
import { FaGift, FaRobot, FaRandom, FaChartLine, FaLock, FaUsers } from 'react-icons/fa';
import { Link as RouterLink } from 'react-router-dom';
import Footer from '../components/Footer';
import AirdropHistory from '../components/AirdropHistory';

const Rewards = () => {
  return (
    <Box bg="gray.900" minH="100vh" pt="80px" color="white">
      <Container maxW="container.xl" py={20}>
        <VStack spacing={12}>
          {/* Hero Section */}
          <VStack spacing={4} textAlign="center">
            <Heading 
              size="2xl" 
              bgGradient="linear(to-r, cyan.400, blue.500)" 
              bgClip="text"
              fontWeight="extrabold"
            >
              HODL Rewards
            </Heading>
            <Text fontSize="xl" color="gray.300" maxW="800px">
              AI-controlled SOL rewards distributed to randomly selected holders
            </Text>
          </VStack>

          {/* How Rewards Work */}
          <Box bg="blue.900" p={8} rounded="lg" w="full" boxShadow="xl">
            <VStack spacing={6}>
              <Heading size="lg" color="cyan.400">How Rewards Work</Heading>
              <Text fontSize="lg" textAlign="center" maxW="800px">
                Our AI-powered reward system automatically selects 5-10 random wallets each day to receive SOL rewards.
                The longer you hold, the more chances you have of receiving multiple rewards.
              </Text>
              <SimpleGrid columns={{ base: 1, md: 3 }} spacing={8} w="full">
                <VStack p={6} bg="blue.800" rounded="lg" boxShadow="md">
                  <FaRobot size={32} color="#81E6D9" />
                  <Heading size="md" color="cyan.400">AI-Controlled</Heading>
                  <Text textAlign="center">
                    Rewards are controlled and audited by AI for fairness
                  </Text>
                </VStack>
                <VStack p={6} bg="blue.800" rounded="lg" boxShadow="md">
                  <FaRandom size={32} color="#81E6D9" />
                  <Heading size="md" color="cyan.400">Random Selection</Heading>
                  <Text textAlign="center">
                    5-10 wallets chosen randomly each day
                  </Text>
                </VStack>
                <VStack p={6} bg="blue.800" rounded="lg" boxShadow="md">
                  <FaChartLine size={32} color="#81E6D9" />
                  <Heading size="md" color="cyan.400">Volume-Based</Heading>
                  <Text textAlign="center">
                    Higher volume means bigger rewards
                  </Text>
                </VStack>
              </SimpleGrid>
            </VStack>
          </Box>

          {/* Airdrop History Section */}
          <Box bg="blue.900" p={8} rounded="lg" w="full" boxShadow="xl">
            <VStack spacing={6}>
              <Heading size="lg" color="cyan.400">Recent Airdrops</Heading>
              <AirdropHistory />
            </VStack>
          </Box>

          {/* Reward Details */}
          <Box bg="blue.900" p={8} rounded="lg" w="full" boxShadow="xl">
            <VStack spacing={6}>
              <Heading size="lg" color="cyan.400">Reward Details</Heading>
              <SimpleGrid columns={{ base: 1, md: 2 }} spacing={8} w="full">
                <Box p={6} bg="blue.800" rounded="lg" boxShadow="md">
                  <Heading size="md" color="cyan.400" mb={4}>Eligibility</Heading>
                  <List spacing={3}>
                    <ListItem>
                      <ListIcon as={FaUsers} color="cyan.400" />
                      All token holders are eligible for rewards
                    </ListItem>
                    <ListItem>
                      <ListIcon as={FaLock} color="cyan.400" />
                      Liquidity pool token locker excluded
                    </ListItem>
                    <ListItem>
                      <ListIcon as={FaLock} color="cyan.400" />
                      Token creator excluded
                    </ListItem>
                    <ListItem>
                      <ListIcon as={FaGift} color="cyan.400" />
                      Longer holding time increases chances
                    </ListItem>
                  </List>
                </Box>
                <Box p={6} bg="blue.800" rounded="lg" boxShadow="md">
                  <Heading size="md" color="cyan.400" mb={4}>Reward Process</Heading>
                  <List spacing={3}>
                    <ListItem>
                      <ListIcon as={FaRobot} color="cyan.400" />
                      AI selects 5-10 random wallets daily
                    </ListItem>
                    <ListItem>
                      <ListIcon as={FaChartLine} color="cyan.400" />
                      Reward size based on trading volume
                    </ListItem>
                    <ListItem>
                      <ListIcon as={FaGift} color="cyan.400" />
                      Rewards distributed automatically
                    </ListItem>
                    <ListItem>
                      <ListIcon as={FaUsers} color="cyan.400" />
                      AI cycles through wallets over time
                    </ListItem>
                  </List>
                </Box>
              </SimpleGrid>
            </VStack>
          </Box>

          {/* Call to Action */}
          <Box textAlign="center" w="full">
            <VStack spacing={6}>
              <Text fontSize="xl" color="gray.300">
                Start receiving rewards today
              </Text>
              <Button
                as={RouterLink}
                to="/how-it-works"
                size="lg"
                colorScheme="cyan"
                bgGradient="linear(to-r, cyan.400, blue.500)"
                _hover={{
                  bgGradient: "linear(to-r, cyan.500, blue.600)",
                }}
                px={8}
              >
                Get Started
              </Button>
            </VStack>
          </Box>
        </VStack>
      </Container>
      
      <Footer />
    </Box>
  );
};

export default Rewards; 